export const tagsObj = {
	"FAN_RANK_1": "/icons/chatTags/fanRankOne.png",

	"FAN_RANK_2": "/icons/chatTags/fanRankTwo.png",

	"FAN_RANK_3": "/icons/chatTags/fanRankThree.png",

	"TOP_DONOR": "/icons/chatTags/topDonorTag.png",

	"HOST": "/icons/chatTags/hostTag.png",

	"NEW_USER" : "/icons/chatTags/newUserTag.png",
	"PRO_USER" : "/icons/chatTags/proBadge.png",

	/* This is for Chat Moderators */
	"BROADCAST_MODERATOR": "/icons/chatTags/modTag.png"
};

export const emotesList = {
	"Wow"       : "https://images.rooter.gg/rooter-content-new/incoming/Wow.png",
	"OP"        : "https://images.rooter.gg/rooter-content-new/incoming/OP.png",
	"GoodGame"  : "https://images.rooter.gg/rooter-content-new/incoming/GoodGame.png",
	"Noob"      : "https://images.rooter.gg/rooter-content-new/incoming/Noob.png",
	"RIP"       : "https://images.rooter.gg/rooter-content-new/incoming/RIP.png",
	"AngryFace" : "https://images.rooter.gg/rooter-content-new/incoming/AngryFace.png",
	"Like"      : "https://images.rooter.gg/rooter-content-new/incoming/Like.png"
};
